export const formFieldComponents = {
  email: 'FormFieldsEmailField',
  password: 'FormFieldsPasswordField',
  text: 'FormFieldsTextField',
};
